import axios from "axios";
import { API_HOST } from "@/core/variables";

class AnswerRepository {
    predictAnswer = async (query: string, agentToken: string) => {
        return axios.get(`${API_HOST}/v1/service/intent`, {
            params: {
                query: query,
                agent_token: agentToken,
                debug: true,
                category: '',
                source: "nlu-web",
                channel: "try_it_out",
            }
        });
    };
}

const answerRepository = new AnswerRepository();

export default answerRepository;
